import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function MicroAtmPos() {
  const faqs = [
    {
      question: "What is Mokshiq Micro ATM (mATM) POS Software?",
      answer: "Micro ATM POS Software (by Rakle Service Private Limited) transforms handheld Bluetooth POS devices into cash withdrawal terminals using Debit Cards (RuPay, Visa, Mastercard)."
    },
    {
      question: "Which mATM hardware devices are compatible?",
      answer: "We support PAX D180, Pax D190, WisePad 2, MoreFun, and Bluetooth Micro ATM devices."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-credit-card me-2"></i>Handheld POS Cash Withdrawal
            </span>
            <h1 className="page_title text-white mb-3">Micro ATM (mATM) POS Software</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Turn retail shops into neighborhood ATMs using Bluetooth mATM devices powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Banking Software</a></li>
              <li className="active"><a href="#!">Micro ATM POS</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-credit-card text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Debit Card Cash Out</h3>
                  <p className="text-muted small">Swipe or chip insert for RuPay, Visa, and Mastercard debit cards with PIN entry security.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-coins text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Flat ₹12 Commission</h3>
                  <p className="text-muted small">Earn attractive flat commissions per cash withdrawal transaction on your mATM device.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-receipt text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Balance Inquiry &amp; Thermal Slip</h3>
                  <p className="text-muted small">Check bank account balance and print instant thermal paper receipt slips for customers.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Micro ATM FAQs" subtitle="Frequently asked questions about Micro ATM POS devices and software." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default MicroAtmPos;
